var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TileComment, TileHeader, Tile } from '../common/Tile';
import { EllipsisOneLine, EllipsisThreeLines, } from '@bootstraplabs/bsw-common-react';
import { ContentBox, ContentImage } from '../content/ContentCommon';
export function VideoTile(props) {
    return (_jsxs(Tile, __assign({ onClick: props.onClick, span: props.span }, { children: [_jsx(TileHeader, { children: _jsx(EllipsisOneLine, { children: props.name }, void 0) }, void 0),
            _jsx(ContentBox, { children: _jsx(ContentImage, { src: props.imageUrl }, void 0) }, void 0),
            _jsx(TileComment, { children: _jsx(EllipsisThreeLines, { children: props.description }, void 0) }, void 0)] }), void 0));
}
//# sourceMappingURL=video-tile.js.map